import { QueryProps } from "@/api/api";
import { AUTO } from "@/dateRanges/windowSizes";
import { getAutoWindowSize } from "@/dateRanges/DateRangeContext";
import { apiClient } from "@/api/client";

export const getQueryFn = <ResponseType = Record<string, any>>(query: QueryProps, apiPath: string) => {
  const { dateRange, windowSize, ...otherQueryProps } = query

  const start = dateRange.value.from()
  const stop = dateRange.value.to()
  const window_size = windowSize === AUTO ? getAutoWindowSize(dateRange).value : windowSize.value;

  return async () => {
    const response = await apiClient.post<ResponseType>(
      apiPath,
      {
        ...otherQueryProps,
        window_size,
        start,
        stop,
        timezone_for_bucketing: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    );
    return response.data;
  };
};
